(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-generics-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-generics-guide')) {
  customElements.define('sc-generics-guide',class extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;this.ready=true;
      const dialog=this.querySelector('dialog');
      const button=this.querySelector('.sc-guide-reopen');
      if(!dialog || typeof dialog.showModal!=='function')return;
      const key='sc-generics-guide-seen';
      const seen=()=>{
        try{return sessionStorage.getItem(key)==='1'||window.scGenericsGuideSeen===true;}
        catch(error){return window.scGenericsGuideSeen===true;}
      };
      const open=()=>{
        if(!dialog.open)dialog.showModal();
        window.scGenericsGuideSeen=true;
        try{sessionStorage.setItem(key,'1');}catch(error){}
      };
      button.addEventListener('click',open);
      this.querySelector('.sc-guide-close').addEventListener('click',()=>dialog.close());
      this.querySelector('.sc-guide-start').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('close',()=>button.focus());
      const positionAndOpen=()=>{
        const main=document.querySelector('#MainContent')||document.querySelector('main');
        const heading=main?.querySelector('.collection-hero__title, .sc-search-page > h1, h1');
        if(heading)heading.before(this);
        if(!seen())open();
      };
      if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',positionAndOpen,{once:true});else positionAndOpen();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-home-logo"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sc-home-logo'))customElements.define('sc-home-logo',class extends HTMLElement{
 connectedCallback(){
  if(this.initialized)return;this.initialized=true;
  const button=this.querySelector('button');
  let context;try{context=document.createElement('canvas').getContext('webgl2');}catch(error){}
  if(!context)return;
  context.getExtension('WEBGL_lose_context')?.loseContext();
  const viewer=this.querySelector('template').content.firstElementChild.cloneNode(true);
  const motion=matchMedia('(prefers-reduced-motion: reduce)');
  const pause=(value)=>{viewer.toggleAttribute('auto-rotate',!value);button.textContent=value?'Start rotation':'Pause rotation';button.setAttribute('aria-pressed',String(value));};
  viewer.addEventListener('load',()=>{this.setAttribute('data-loaded','');button.hidden=false;});
  viewer.addEventListener('error',()=>{this.removeAttribute('data-loaded');viewer.remove();button.hidden=true;});
  pause(motion.matches);button.onclick=()=>pause(viewer.hasAttribute('auto-rotate'));
  this.querySelector('.sc-logo-stage').appendChild(viewer);
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-model-group"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sc-model-group'))customElements.define('sc-model-group',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;
    const section=this.closest('section[id^="MainProduct-"]');
    const gallery=section?.querySelector('media-gallery');
    if(!gallery)return;
    this.ready=true;this.section=section;this.gallery=gallery;
    this.select=this.querySelector('select');
    this.items=[...gallery.querySelectorAll('[id^="GalleryViewer"] [data-media-id]')];
    this.select.addEventListener('change',()=>this.activate());
    this.querySelector('.sc-group-prev').addEventListener('click',()=>this.step(-1));
    this.querySelector('.sc-group-next').addEventListener('click',()=>this.step(1));
    gallery.classList.add('sc-group-gallery');gallery.prepend(this);
    const requested=new URLSearchParams(location.search).get('generic_model');
    if([...this.select.options].some(option=>option.value===requested))this.select.value=requested;
    customElements.whenDefined('product-model').then(()=>{if(this.isConnected)this.activate();});
  }
  step(direction){this.select.selectedIndex=(this.select.selectedIndex+direction+this.select.options.length)%this.select.options.length;this.activate();}
  activate(){
    const id=this.select.value;
    const active=this.items.find(item=>item.dataset.mediaId.endsWith('-'+id));
    if(!active)return;
    for(const item of this.items){
      item.toggleAttribute('data-sc-group-hidden',item!==active);
      item.toggleAttribute('data-sc-group-active',item===active);
      item.classList.toggle('is-active',item===active);
      if(item!==active)item.querySelectorAll('model-viewer').forEach(viewer=>viewer.pause?.());
    }
    active.querySelector('product-model')?.loadContent(false);
    this.querySelector('[data-sc-group-status]').textContent=(this.select.selectedIndex+1)+' / '+this.select.options.length+' — '+this.select.selectedOptions[0].textContent;
    this.section.querySelectorAll('[data-sc-quote-link],a[href*="pages/printgorilla?generic_design="]').forEach(link=>{
      const url=new URL(link.href,location.origin);url.searchParams.set('generic_model',id);link.href=url.href;
    });
    this.section.querySelectorAll('input[name="properties[Design]"]').forEach(input=>input.remove());
    const form=this.section.querySelector('form[action*="/cart/add"]');
    if(form){const input=document.createElement('input');input.type='hidden';input.name='properties[Design]';input.value=this.select.selectedOptions[0].textContent;form.append(input);}
    const url=new URL(location.href);url.searchParams.set('generic_model',id);history.replaceState(history.state,'',url);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-mould-colour"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-mould-colour')) {
    class SCMouldColour extends HTMLElement {
      static presets = {
  "soap": {
    "colour": "#f2cbd7",
    "alpha": 1,
    "metallic": 0,
    "roughness": 0.65
  },
  "wax": {
    "colour": "#fff1ce",
    "alpha": 1,
    "metallic": 0,
    "roughness": 0.45
  },
  "gummies": {
    "colour": "#d91f32",
    "alpha": 0.82,
    "metallic": 0,
    "roughness": 0.18
  },
  "resin": {
    "colour": "#d3b6ec",
    "alpha": 0.85,
    "metallic": 0,
    "roughness": 0.16
  },
  "concrete": {
    "colour": "#929292",
    "alpha": 1,
    "metallic": 0,
    "roughness": 0.95
  },
  "metal": {
    "colour": "#bfc5cc",
    "alpha": 1,
    "metallic": 0.92,
    "roughness": 0.23
  },
  "baking": {
    "colour": "#c88b45",
    "alpha": 1,
    "metallic": 0,
    "roughness": 0.85
  },
  "ice": {
    "colour": "#a9dcf2",
    "alpha": 0.48,
    "metallic": 0,
    "roughness": 0.12
  },
  "ice_cream": {
    "colour": "#fff0d4",
    "alpha": 1,
    "metallic": 0,
    "roughness": 0.72
  },
  "surf_wax": {
    "colour": "#f5f2e9",
    "alpha": 1,
    "metallic": 0,
    "roughness": 0.8
  },
  "car_wax": {
    "colour": "#e9c65c",
    "alpha": 1,
    "metallic": 0,
    "roughness": 0.42
  },
  "butter": {
    "colour": "#f6dc72",
    "alpha": 1,
    "metallic": 0,
    "roughness": 0.5
  },
  "chocolate": {
    "colour": "#60351f",
    "alpha": 1,
    "metallic": 0,
    "roughness": 0.32
  },
  "other": {
    "colour": "#b8b8b8",
    "alpha": 1,
    "metallic": 0,
    "roughness": 0.55
  }
};
      static defaultChoice = { preset: 'custom', colour: '#003cff', alpha: 1, metallic: 0, roughness: 0.55 };
      static choices = new Map();
      static instances = new Set();

      connectedCallback() {
        if (this.observer) return;
        this.host = this.previousElementSibling;
        if (!this.host || this.host.tagName !== 'PRODUCT-MODEL') return;
        this.picker = this.querySelector('input');
        this.preset = this.querySelector('[data-preset]');
        this.status = this.querySelector('[data-colour-status]');
        this.originals ||= new WeakMap();
        this.boundApply = () => {
          this.apply();
          this.viewer?.dismissPoster?.();
        };
        this.boundError = () => { this.status.textContent = this.status.dataset.error; };
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.picker.addEventListener('input', () => this.choose({ preset: 'custom', colour: this.picker.value, alpha: 1, metallic: 0, roughness: 0.55 }), options);
        this.preset.addEventListener('change', () => {
          const key = this.preset.value;
          if (key === 'original') this.choose(null);
          else if (key === 'custom') this.choose({ preset: 'custom', colour: this.picker.value, alpha: 1, metallic: 0, roughness: 0.55 });
          else if (SCMouldColour.presets[key]) this.choose({ preset: key, ...SCMouldColour.presets[key] });
        }, options);
        this.querySelector('button').addEventListener('click', () => this.choose(null), options);
        this.observer = new MutationObserver(() => this.bindViewer());
        this.observer.observe(this.host, { childList: true, subtree: true });
        if (!SCMouldColour.choices.has(this.dataset.product)) {
          SCMouldColour.choices.set(this.dataset.product, { ...SCMouldColour.defaultChoice });
        }
        SCMouldColour.instances.add(this);
        this.bindViewer();
        this.sync();
        customElements.whenDefined('product-model').then(() => {
          if (!this.isConnected) return;
          if (!this.host.hasAttribute('loaded')) this.host.loadContent(false);
          this.bindViewer();
          this.viewer?.dismissPoster?.();
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        this.events?.abort();
        this.unbindViewer();
        SCMouldColour.instances.delete(this);
      }

      unbindViewer() {
        this.viewer?.removeEventListener('load', this.boundApply);
        this.viewer?.removeEventListener('error', this.boundError);
        this.viewer = null;
      }

      bindViewer() {
        const viewer = this.host.querySelector('model-viewer');
        if (viewer === this.viewer) return;
        this.unbindViewer();
        this.viewer = viewer;
        if (!viewer) return;
        viewer.style.setProperty('background', '#fff', 'important');
        viewer.style.setProperty('--poster-color', '#fff');
        if (this.dataset.highContrast === 'true') {
          viewer.style.setProperty('filter', 'contrast(1.3) brightness(1.04)');
        }
        viewer.addEventListener('load', this.boundApply);
        viewer.addEventListener('error', this.boundError);
        this.apply();
      }

      choose(choice) {
        SCMouldColour.choices.set(this.dataset.product, choice);
        const focusedControl = document.activeElement;
        for (const control of SCMouldColour.instances) {
          if (control.dataset.product === this.dataset.product) control.sync();
        }
        if (!this.viewer && typeof this.host.loadContent === 'function') {
          this.host.loadContent(false);
          this.bindViewer();
          if (this.contains(focusedControl)) focusedControl.focus({ preventScroll: true });
        }
        this.viewer?.dismissPoster?.();
      }

      sync() {
        const choice = SCMouldColour.choices.get(this.dataset.product);
        this.picker.value = choice?.colour || '#b8b8b8';
        this.preset.value = choice?.preset || 'original';
        this.apply();
      }

      apply() {
        const materials = this.viewer?.model?.materials;
        if (!materials?.length) return;
        const choice = SCMouldColour.choices.get(this.dataset.product);
        try {
          for (const material of materials) {
            const pbr = material.pbrMetallicRoughness;
            if (!pbr || typeof pbr.setBaseColorFactor !== 'function') throw new Error();
            if (!this.originals.has(material)) {
              this.originals.set(material, {
                colour: Array.from(pbr.baseColorFactor),
                alphaMode: material.getAlphaMode?.() || 'OPAQUE',
                metallic: pbr.metallicFactor,
                roughness: pbr.roughnessFactor
              });
            }
            const original = this.originals.get(material);
            if (choice) {
              const linear = [1, 3, 5].map(offset => {
                const channel = parseInt(choice.colour.slice(offset, offset + 2), 16) / 255;
                return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
              });
              material.setAlphaMode?.(choice.alpha < 1 ? 'BLEND' : 'OPAQUE');
              pbr.setBaseColorFactor([...linear, choice.alpha]);
              pbr.setMetallicFactor?.(choice.metallic);
              pbr.setRoughnessFactor?.(choice.roughness);
            } else {
              material.setAlphaMode?.(original.alphaMode);
              pbr.setBaseColorFactor(original.colour);
              if (original.metallic !== undefined) pbr.setMetallicFactor?.(original.metallic);
              if (original.roughness !== undefined) pbr.setRoughnessFactor?.(original.roughness);
            }
          }
          this.status.textContent = this.status.dataset.hint;
        } catch (error) {
          this.status.textContent = this.status.dataset.error;
        }
      }
    }
    customElements.define('sc-mould-colour', SCMouldColour);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-red-preview-filter"] && !Shopify.designMode) return;
  try {
    (() => {
    if (document.getElementById('sc-red-model-preview-filter')) return;
    const holder = document.createElement('div');
    holder.innerHTML = `<svg class="sc-preview-filter-definitions" xmlns="http://www.w3.org/2000/svg" width="0" height="0" aria-hidden="true" focusable="false">
  <defs>
    <filter id="sc-red-model-preview-filter" color-interpolation-filters="sRGB">
      <feColorMatrix type="saturate" values="0" />
      <feComponentTransfer>
        <feFuncR type="table" tableValues="0 .02 .035 .06 .08 .10 .13 .16 .20 .28 1" />
        <feFuncG type="table" tableValues="0 .015 .025 .04 .05 .065 .08 .10 .13 .20 1" />
        <feFuncB type="table" tableValues="0 .20 .32 .44 .56 .66 .75 .82 .88 .94 1" />
        <feFuncA type="identity" />
      </feComponentTransfer>
    </filter>
  </defs>
</svg>`;
    document.body.appendChild(holder.firstElementChild);
    const imageKey = (source) => {
      try {
        return new URL(source, document.baseURI).pathname.replace(/^.*\/(?:files|products)\//, '');
      } catch (error) {
        return '';
      }
    };
    const markThumbnails = () => {
      const sources = new Set();
      document.querySelectorAll('product-model:has(+ sc-mould-colour) .deferred-media__poster img').forEach(img => {
        const key = imageKey(img.currentSrc || img.src);
        if (key) sources.add(key);
      });
      if (!sources.size) return;
      document.querySelectorAll('img').forEach(img => {
        if (sources.has(imageKey(img.currentSrc || img.src))) img.setAttribute('data-sc-model-preview', '');
      });
    };
    let frame;
    const observer = new MutationObserver(() => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(markThumbnails);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    markThumbnails();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-rotating-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-rotating-card')) {
  customElements.whenDefined('model-viewer').then(()=>{
    const viewerClass=customElements.get('model-viewer');
    if('minimumRenderScale' in viewerClass)viewerClass.minimumRenderScale=1;
  });
  const cards=new Set();
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const update=()=>{
    for(const card of cards){
      const show=card.visible&&!card.failed&&!document.hidden&&!reduced.matches;
      if(show){card.mount();}else card.unmount();
    }
  };
  const observer=new IntersectionObserver(entries=>{for(const entry of entries)entry.target.visible=entry.isIntersecting;update();},{threshold:0.05});
  document.addEventListener('visibilitychange',update);
  reduced.addEventListener('change',update);
  customElements.define('sc-rotating-card',class extends HTMLElement {
    connectedCallback(){
      if(!this.ready){
        this.ready=true;this.paused=false;
        this.button=this.querySelector('button');
        this.button.addEventListener('click',event=>{
          event.preventDefault();event.stopPropagation();this.paused=!this.paused;
          this.button.textContent=this.paused?this.button.dataset.play:this.button.dataset.pause;
          this.button.setAttribute('aria-pressed',String(this.paused));
          this.viewer?.toggleAttribute('auto-rotate',!this.paused);
        });
      }
      cards.add(this);observer.observe(this);
    }
    mount(){
      if(this.viewer)return;
      const template=this.querySelector('template');
      const viewer=template.content.querySelector('model-viewer').cloneNode(true);
      this.viewer=viewer;
      viewer.removeAttribute('camera-controls');viewer.setAttribute('tabindex','-1');viewer.setAttribute('aria-hidden','true');
      viewer.toggleAttribute('auto-rotate',!this.paused);
      viewer.addEventListener('load',()=>{
        if(this.viewer!==viewer)return;
        try{viewer.model?.materials.forEach(material=>{
          material.setAlphaMode('OPAQUE');
          material.pbrMetallicRoughness.setBaseColorFactor('#003cff');
          material.pbrMetallicRoughness.setMetallicFactor(0);
          material.pbrMetallicRoughness.setRoughnessFactor(.65);
        });}catch(error){}
        this.setAttribute('data-ready','');this.button.hidden=false;
      });
      viewer.addEventListener('error',()=>{this.failed=true;this.unmount();update();});
      this.append(viewer);
    }
    unmount(){
      this.viewer?.remove();this.viewer=null;
      this.removeAttribute('data-ready');if(this.button)this.button.hidden=true;
    }
    disconnectedCallback(){observer.unobserve(this);cards.delete(this);this.unmount();update();}
  });
}
  } catch(e) { console.error(e); }
})();

})();
